import Udesk from 'Udesk';
import React, { CSSProperties, FC, memo, useEffect } from 'react';
import { Checkbox, Form, Input } from 'udesk-ui';
import InspectDataSourceSelect from 'src/components/common/InspectDataSourceSelect';
import CustomFilter from 'src/components/pages/components/CustomFilter';
import MassagePushConfiguration, {
    TemplateProps as MassagePushConfigurationProps,
} from 'src/components/pages/components/massage-push-configuration-v2';
import { BaseFilter } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const fieldStyle: CSSProperties = {
    width: 300,
};

export interface TemplateProps {
    value?: {
        name?: string;
        inspectDataSource?: number;
        baseFilter?: BaseFilter;
        eventSources?: string[];
        pushMethod?: MassagePushConfigurationProps['value'];
    };
    onChange?: (v: TemplateProps['value']) => void;
    querryType?: string;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, querryType } = props;

    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, [form]);

    const onDataSourceTypeChange = () => {
        form.setFieldsValue({
            filter: undefined,
        });
    };

    const onValuesChange = (v: TemplateProps['value']) => {
        onChange?.(v);
    };

    return (
        <Form
            form={form}
            initialValues={value}
            onValuesChange={(changeValue, values) => onValuesChange(values)}
        >
            <Form.Item label={/* 消息名称 */UdeskLocales['current'].components.massageConfigurationV2.index.messageName} name="name">
                <Input style={fieldStyle} />
            </Form.Item>

            <Form.Item label={/* 数据类型 */UdeskLocales['current'].components.massageConfigurationV2.index.dataType} name="inspectDataSource">
                <InspectDataSourceSelect
                    style={fieldStyle}
                    filterList={[
                        Udesk.enums.inspectDataSources.voiceCall.id,
                        Udesk.enums.inspectDataSources.textDialogue.id,
                        Udesk.enums.inspectDataSources.ticket.id,
                        Udesk.enums.inspectDataSources.videoCall.id,
                        Udesk.enums.inspectDataSources.survey.id,
                        Udesk.enums.inspectDataSources.eComment.id,
                        Udesk.enums.inspectDataSources.mComment.id,
                        Udesk.enums.inspectDataSources.wechatDialogue.id,
                        Udesk.enums.inspectDataSources.wechatRadio.id,
                    ]}
                    onChange={onDataSourceTypeChange}
                />
            </Form.Item>

            <Form.Item noStyle shouldUpdate>
                {({ getFieldsValue }) => {
                    const type = getFieldsValue().inspectDataSource;

                    return (
                        <Form.Item label={/* 筛选条件 */UdeskLocales['current'].components.massageConfigurationV2.index.filterCondition} name="baseFilter">
                            <CustomFilter type={type} querryType={querryType} />
                        </Form.Item>
                    );
                }}
            </Form.Item>

            <Form.Item label={/* 触发机制 */UdeskLocales['current'].components.massageConfigurationV2.index.triggerMechanism} name="eventSources">
                <Checkbox.Group
                    options={[
                        {
                            label: /* 数据获取后 */UdeskLocales['current'].components.massageConfigurationV2.index.afterDataAcquisition,
                            value: 'voc_data_get',
                        },
                        {
                            label: /* 数据分析后 */UdeskLocales['current'].components.massageConfigurationV2.index.afterDataAnalysis,
                            value: 'voc_data_analysis',
                        },
                    ]}
                />
            </Form.Item>

            <Form.Item noStyle shouldUpdate>
                {({ getFieldsValue }) => {
                    const type = getFieldsValue().inspectDataSource;

                    return (
                        <Form.Item label={/* 推送方式 */UdeskLocales['current'].components.massageConfigurationV2.index.pushMode} name="pushMethod">
                            <MassagePushConfiguration
                                taskType={type}
                                type={Udesk.enums.messageType.trigger.id}
                                showPresetPushUser={false}
                                pushTypeFilter={[
                                    Udesk.enums.sdkPushType.dingDing.id,
                                    Udesk.enums.sdkPushType.weChat.id,
                                    Udesk.enums.sdkPushType.customer.id,
                                ]}
                                showCustomPushEmail={true}
                            />
                        </Form.Item>
                    );
                }}
            </Form.Item>
        </Form>
    );
});

export default Template;
